import { render } from "./GamesCatalogPage.vue?vue&type=template&id=13fcbb0f&scoped=true"
import script from "./GamesCatalogPage.vue?vue&type=script&lang=js"
export * from "./GamesCatalogPage.vue?vue&type=script&lang=js"

import "./GamesCatalogPage.vue?vue&type=style&index=0&id=13fcbb0f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\casva\\repos\\cg-vue-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13fcbb0f"]])

export default __exports__